import { render, staticRenderFns } from "./cDocumentCheckStatus.vue?vue&type=template&id=86c0e77c&scoped=true"
import script from "./cDocumentCheckStatus.vue?vue&type=script&lang=js"
export * from "./cDocumentCheckStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c0e77c",
  null
  
)

export default component.exports